<template lang="pug">
div(:class="[alignmentClasses, { 'relative': $storyblok.isEditing }]")
    QueryInput(
        v-if="$searchContext && $parentId"
        type="text"
        :placeholder='data.placeholder'
        :updateRoute="false"
        class="border border-gray-light rounded color-dark bg-white bg-no-repeat w-full text-sm p-3 md:max-w-screen-sm md:h-16 md:p-4 md:m-auto md:text-base"
    )

    div(v-else-if="$storyblok.isEditing" class="p-2 mb-4 text-sm text-center bg-danger-light border border-danger rounded") Error: The Search Input Widget may only be used inside of a Search Content Wrapper.

    //- Shade for storyblok editor to prevent clicks
    div(
        v-if="$storyblok.isEditing"
        class="absolute inset-0 z-50"
    )
</template>

<script>
import QueryInput from '@/components/search/queryInput'
import SearchComponent from '@/components/search/component'
import { generateTextAlignmentClasses } from '~/integrations/storyblok/helpers'

export default {
    components: {
        QueryInput,
    },
    extends: SearchComponent,
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        alignmentClasses() {
            return generateTextAlignmentClasses(
                this.data.mobileAlignment,
                this.data.tabletAlignment,
                this.data.desktopAlignment
            )
        },
    },
}
</script>
